import { useCallback, useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
// @mui
import {
    Box,
    Button,
    Card,
    Container,
    IconButton,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
// components
import Iconify from '../components/iconify';
import Label from '../components/label';
// sections
import { UserListToolbar } from '../sections/@dashboard/user';
// mock
import { ButtonGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import AddButton from 'src/components/Button.js/AddBotton';
import ConfirmLockModal from 'src/components/modal/ConfirmLockModal';
import { glb_sv, sendRequest, serviceList } from 'src/utils';

import Breadcrumb from 'src/components/Breadcrumb/Breadcrumb';
import Loader from 'src/components/loader/loader';

import debounce from 'lodash/debounce';
import CreateUserAdminModal from 'src/components/modal/CreateUserAdminModal';

// ----------------------------------------------------------------------

export default function ManagerAdmin() {
    const { t } = useTranslation();
    const TABLE_HEAD = [
        // { id: 'info'},
        { id: 'name', label: t('name'), alignRight: false },
        { id: 'account', label: t('account'), alignRight: false },
        { id: 'Email', label: 'Email', alignRight: false },
        { id: 'phone_supplier', label: t('phone_supplier'), alignRight: false },
        { id: 'department', label: t('department'), alignRight: false },
        { id: 'status', label: t('status'), alignRight: false },
        { id: '' },
    ];
    const params = useParams();
    const [visibleDel, setVisibleLock] = useState(false);
    const throttled = useRef(debounce(() => getData(), 1000));

    const [getFlags, setGetFlags] = useState(false);
    const isEdit = useRef(false);
    const [tableData, setTableData] = useState([]);
    const lock = useRef(false);
    const [deleleFlags, setLockFlags] = useState(false);

    const [dataAction, setDataAction] = useState({});

    const [visible, setVisible] = useState(false);

    const searchValueDeboun = useRef('');
    const arrFillters = useRef([]);
    const [total, setTotal] = useState(0);

    const getRef = useRef(false);
    const lastID = useRef(0);

    const [tableDataExcel, setTableDataExcel] = useState([]);
    const [getFlagsExcel, setGetFlagsExcel] = useState(false);
    const getRefExcel = useRef(false);
    const [needGetDataNext, setNeedGetDataNext] = useState(false);
    const [totalExcel, setTotalExcel] = useState(0);
    const lastIDExcel = useRef(0);

    const [getDetailFlags, setGetDetailFlags] = useState(false);
    const getRefDetail = useRef(false);

    useEffect(() => {
        setTimeout(() => {
            getData();
        }, 1000);
    }, []);

    useEffect(() => {
        setTimeout(() => {
            getDataExcel();
        }, 1500);
    }, []);

    useEffect(() => {
        if (needGetDataNext) {
            getDataNextExcel();
            setNeedGetDataNext(false);
        }
    }, [needGetDataNext]);

    // Lấy dữ liệu danh sách nhân viên dành cho xuất excel
    const getDataExcel = useCallback(() => {
        if (getRefExcel.current) {
            return;
        }
        setGetFlagsExcel(true);
        getRefExcel.current = true;
        const InVal = [9999999999999999999, (searchValueDeboun?.current || '')?.toUpperCase()];
        sendRequest(serviceList.getAllAdmmin, InVal, getDataResultExcel, true, timeOutFunctExcel, 40000);
    }, []);

    const getDataResultExcel = (reqInfoMap, message) => {
        setGetFlagsExcel(false);
        getRefExcel.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            return;
        } else {
            const data = message.proc_data.rows[0].o_1;
            setTableDataExcel(message.proc_data.rows[0].o_1);
            setTotalExcel(message.proc_data.rowTotal);
            lastIDExcel.current = message.proc_data.rows[0].o_1?.at(-1)?.id;
            if (data.length < message.proc_data.rowTotal) {
                setNeedGetDataNext(true);
            }
        }
    };

    const getDataNextExcel = () => {
        if (getRefExcel.current) {
            return;
        }
        setGetFlagsExcel(true);
        getRefExcel.current = true;
        const InVal = [lastIDExcel.current, (searchValueDeboun?.current || '')?.toUpperCase()];
        sendRequest(serviceList.getAllAdmmin, InVal, getDataResultNextExcel, true, timeOutFunctExcel, 40000);
    };

    const getDataResultNextExcel = (reqInfoMap, message) => {
        setGetFlagsExcel(false);
        getRefExcel.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            return;
        } else {
            const dataNewExcel = [...message.proc_data.rows[0].o_1, ...tableDataExcel];
            setTableDataExcel([...message.proc_data.rows[0].o_1, ...tableDataExcel]);
            setTotal(message.proc_data.rowTotal);
            if (message.proc_data.rows[0].o_1?.length > 0) {
                lastIDExcel.current = message.proc_data.rows[0].o_1?.at(-1)?.id;
                if (dataNewExcel.length < message.proc_data.rowTotal) {
                    setNeedGetDataNext(true);
                }
            }
        }
    };
    const timeOutFunctExcel = (reqInfo) => {
        getRefExcel.current = false;
        setGetFlagsExcel(false);
    };

    // Hiển thị danh sách nhân viên
    const getData = useCallback(() => {
        if (getRef.current) {
            return;
        }
        setGetFlags(true);
        getRef.current = true;
        const InVal = [9999999999999999999, (searchValueDeboun?.current || '')?.toUpperCase()];
        sendRequest(serviceList.getAllAdmmin, InVal, getDataResult, true, timeOutFunct, 40000);
    }, []);

    const getDataResult = (reqInfoMap, message) => {
        setGetFlags(false);
        getRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const data = message.proc_data.rows[0].o_1 || [];
            if (data && data.length > 0) {
                setTableData(message.proc_data.rows[0].o_1);
                setTotal(message.proc_data.rowTotal);
                lastID.current = message.proc_data.rows[0].o_1?.at(-1)?.id;
                arrFillters.current = message.proc_data.rows[0].o_1;
            }
        }
    };
    const getDataNext = () => {
        if (getRef.current) {
            return;
        }
        setGetFlags(true);
        getRef.current = true;
        const InVal = [lastID.current, (searchValueDeboun?.current || '')?.toUpperCase()];
        sendRequest(serviceList.getAllAdmmin, InVal, getDataResultNext, true, timeOutFunct, 40000);
    };

    const getDataResultNext = (reqInfoMap, message) => {
        setGetFlags(false);
        getRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setTableData([...tableData, ...message.proc_data.rows[0].o_1]);
            setTotal(message.proc_data.rowTotal);
            if (message.proc_data.rows[0].o_1?.length > 0) {
                lastID.current = message.proc_data.rows[0].o_1?.at(-1)?.id;

                arrFillters.current = message.proc_data.rows[0].o_1;
            }
        }
    };

    const timeOutFunct = (reqInfo) => {
        getRef.current = false;
        setGetFlags(false);
        // toast.error(t('error.time_out' + 11));
    };

    const handleLock = () => {
        if (!dataAction.id) return toast.error(t('error.system_error'));
        if (lock.current) {
            return;
        }
        setLockFlags(true);
        lock.current = true;
        const InVal = [dataAction.id, dataAction.block === '1' ? '0' : '1'];
        sendRequest(serviceList.lockstaff, InVal, deleteResult, true, timeOutFunctDel, 40000);
    };

    const deleteResult = (reqInfoMap, message) => {
        setLockFlags(false);
        lock.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            setVisibleLock(false);
            return;
        } else {
            toast.success(message['proc_message']);
            setVisibleLock(false);
            getByIdUser(dataAction.id);
            // getData();
        }
    };

    const timeOutFunctDel = (reqInfo) => {
        setLockFlags(false);
        lock.current = false;
        toast.error(t('error.time_out'));
    };

    //Lấy thông tin chi tiết của user
    const getByIdUser = (userId) => {
        if (!userId) {
            return;
        }
        if (getRefDetail.current) {
            return;
        }
        getRefDetail.current = true;
        setGetDetailFlags(true);
        const Inval = [userId];
        sendRequest(serviceList.getByIdStaffBase, Inval, getByIdUserResult, true, timeOutFunctGetByIdUser, 40000);
    };

    const getByIdUserResult = (reqInfoMap, message) => {
        getRefDetail.current = false;
        setGetDetailFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            let data = message.proc_data.rows[0].o_1;
            const updatedArray = updateTableData(tableData, data[0]);
            setTableData(updatedArray);
        }
    };

    const timeOutFunctGetByIdUser = (reqInfo) => {
        getRefDetail.current = false;
        setGetDetailFlags(false);
        toast.error(t('error.time_out'));
    };

    // Hàm cập nhật mảng dữ liệu
    const updateTableData = (array, newData) => {
        return array.map((item) => {
            if (item.id === newData.id) {
                return { ...item, ...newData };
            }
            return item;
        });
    };

    const searchValue = (value) => {
        if (!value) {
            value = '';
        }
        searchValueDeboun.current = value;
        // setvalueSearch(value);
        throttled.current();
    };
    return (
        <>
            <Helmet>
                <title> {t('admin_list')} </title>
            </Helmet>

            <Container>
                <Loader loading={getFlags} />
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1} flexWrap={'wrap'}>
                    <Typography variant="h4" gutterBottom>
                        {t('admin_list')}
                    </Typography>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={0} gap={1}></Stack>
                </Stack>
                <Breadcrumb paths={[{ label: t('admin_list'), url: '#', navigate: false }]} />
                <CreateUserAdminModal
                    fuctGet={getData}
                    idPermission={params.idPermission}
                    setVisible={setVisible}
                    visible={visible}
                    isEdit={isEdit.current}
                    dataUpdate={dataAction}
                    fuctGetById={getByIdUser}
                />
                <Card>
                    <UserListToolbar getValue={searchValue} />
                    <ConfirmLockModal
                        visible={visibleDel}
                        setVisible={setVisibleLock}
                        loading={deleleFlags}
                        handleSave={handleLock}
                    />

                    {/* <Scrollbar sx={{ padding: 2 }}> */}
                    <TableContainer sx={{ padding: 1, width: '100%' }}>
                        <Table sx={{ paddingLeft: 2, width: '100%' }}>
                            {/* <UserListHead headLabel={TABLE_HEAD} /> */}
                            <TableHead>
                                <TableRow>
                                    {TABLE_HEAD.map((item, index) => {
                                        return <TableCell key={index}>{item.label}</TableCell>;
                                    })}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tableData.length > 0 &&
                                    tableData.map((item, index) => {
                                        return (
                                            <TableRow hover key={index} tabIndex={-1} role="checkbox">
                                                <TableCell component="th" scope="row">
                                                    <Typography variant="subtitle2" noWrap>
                                                        {index + 1}. {item.user_nm}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell align="left" width={200} style={{ minWidth: '150px' }}>
                                                    {item.accounts}
                                                </TableCell>
                                                <TableCell align="left" width={200}>
                                                    {item.email}
                                                </TableCell>
                                                <TableCell align="left">{`${item.phone}`}</TableCell>
                                                <TableCell align="left" style={{ minWidth: '150px' }}>
                                                    {item.key_mean ? item.key_mean : '---'}
                                                </TableCell>
                                                <TableCell align="left">
                                                    <Label color={(item.block === '0' && 'error') || 'primary'}>
                                                        {item.block === '1' ? t('active') : t('band')}
                                                    </Label>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <ButtonGroup
                                                        variant="text"
                                                        aria-label="text button group"
                                                        style={{ display: 'flex', justifyContent: 'space-between' }}
                                                    >
                                                        <IconButton
                                                            size="large"
                                                            color={'warning'}
                                                            onClick={() => {
                                                                setDataAction(item);
                                                                isEdit.current = true;
                                                                setVisible(true);
                                                            }}
                                                        >
                                                            <Iconify icon={'eva:edit-fill'} />
                                                        </IconButton>
                                                        <IconButton
                                                            size="large"
                                                            color={(item.block === '0' && 'error') || 'primary'}
                                                            onClick={() => {
                                                                setDataAction(item);
                                                                setVisibleLock(true);
                                                            }}
                                                        >
                                                            <Iconify
                                                                icon={
                                                                    item.block !== '1'
                                                                        ? 'material-symbols:lock'
                                                                        : 'material-symbols:lock-open'
                                                                }
                                                            />
                                                        </IconButton>
                                                    </ButtonGroup>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box display={'flex'} justifyContent={'space-between'} padding={2}>
                        <Stack>
                            <span>
                                {t('total_row')}: {tableData.length}/{total}
                            </span>
                        </Stack>
                        <Button
                            variant="contained"
                            endIcon={<Iconify icon="material-symbols:skip-next-rounded" />}
                            onClick={getDataNext}
                            disabled={tableData.length < total ? false : true}
                        >
                            {t('next')}
                        </Button>
                    </Box>
                    {/* </Scrollbar> */}
                </Card>
            </Container>
            <AddButton
                onClick={() => {
                    isEdit.current = false;
                    setVisible(true);
                    setDataAction({});
                }}
            />
        </>
    );
}
